// src/components/BottomNavigation.jsx
import React from 'react';
import { FiGrid, FiMap, FiClock } from 'react-icons/fi';
import './../styles/BottomNavigation.css';

// eslint-disable-next-line no-unused-vars -- MainIcon is used as a component passed as a prop
const IconWithClock = ({ MainIcon, showClock }) => (
  <span className="icon-wrapper">
    <MainIcon />
    {showClock && <FiClock className="clock-indicator-overlay-icon" />}
  </span>
);

const BottomNavigation = ({ activeView, onNavigate, className }) => {
  const handleNavClick = (data, view) => {
    if (onNavigate) {
      onNavigate({ data, view });
    }
  };

  // activeView is an object: { dataMode: 'current'/'historical', viewMode: 'gallery'/'map' }
  const isListingsGalleryActive = activeView.dataMode === 'current' && activeView.viewMode === 'gallery';
  const isListingsMapActive = activeView.dataMode === 'current' && activeView.viewMode === 'map';
  const isPastSalesGalleryActive = activeView.dataMode === 'historical' && activeView.viewMode === 'gallery';
  const isPastSalesMapActive = activeView.dataMode === 'historical' && activeView.viewMode === 'map';

  return (
    <nav id="mobile-bottom-nav" className={`bottom-navigation ${className || ''}`}>
      <div className="bottom-nav-section">
        <span className="section-label">My Listings</span>
        <div className="buttons-group">
          <button
            className={`nav-button ${isListingsGalleryActive ? 'active' : ''}`}
            onClick={() => handleNavClick('current', 'gallery')}
            aria-label="Listings Gallery"
          >
            <FiGrid />
            <span className="button-label">Gallery</span>
          </button>
          <button
            className={`nav-button ${isListingsMapActive ? 'active' : ''}`}
            onClick={() => handleNavClick('current', 'map')}
            aria-label="Listings Map"
          >
            <FiMap />
            <span className="button-label">Map</span>
          </button>
        </div>
      </div>

      <div className="vertical-divider"></div>

      <div className="bottom-nav-section">
        <span className="section-label">Past Sales</span>
        <div className="buttons-group">
          <button
            className={`nav-button ${isPastSalesGalleryActive ? 'active' : ''}`}
            onClick={() => handleNavClick('historical', 'gallery')}
            aria-label="Past Sales Gallery"
          >
            <IconWithClock MainIcon={FiGrid} showClock={true} />
            <span className="button-label">Gallery</span>
          </button>
          <button
            className={`nav-button ${isPastSalesMapActive ? 'active' : ''}`}
            onClick={() => handleNavClick('historical', 'map')}
            aria-label="Past Sales Map"
          >
            <IconWithClock MainIcon={FiMap} showClock={true} />
            <span className="button-label">Map</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default BottomNavigation;
